import { combineReducers } from '@reduxjs/toolkit';
import { editSlice } from '../edit/store';
import { feesSlice } from '../fees/store';
import { portfoliosSlice } from '../portfolios/store';
import { TemplatesState } from './types';
import { reportsSlice } from '../reports/store';
import { reportSettingsSlice } from '../report-settings/store'; // TODO: fix -> remove slice

export const templatesReducer = combineReducers<TemplatesState>({
  fees: feesSlice.reducer,
  portfolios: portfoliosSlice.reducer,
  reportsTemplate: reportsSlice.reducer,
  reportSettingsState: reportSettingsSlice.reducer,
  edit: editSlice.reducer,
});
